import { environmentDefaults } from './environment-defaults';
import * as defaultsDeep from 'lodash.defaultsdeep';
import { API_ENDPOINTS } from './api-endpoints';

const override = {
  PERFORM_APP_DYNAMICS: API_ENDPOINTS.PERFORM_APP_DYNAMICS.PROD,
  hostname: API_ENDPOINTS.HOSTNAME.PROD,
  RTI_ENDPOINT: API_ENDPOINTS.RTI_ENDPOINT.PROD,
  RTI_X_API_VALUE: API_ENDPOINTS.RTI_X_API_VALUE.PROD,
  RTI_X_API_KEY: API_ENDPOINTS.RTI_X_API_KEY.COMMON,
  PP_ENDPOINT: API_ENDPOINTS.PP_ENDPOINT.PROD,
  APP_DYNAMIC_KEY: API_ENDPOINTS.APP_DYNAMIC_KEY.PROD,
  DIS_ENDPOINT: API_ENDPOINTS.DIS_ENDPOINT.PROD,
  DIS_X_API_VALUE: API_ENDPOINTS.DIS_X_API_VALUE.PROD,
  DIS_X_API_KEY: API_ENDPOINTS.DIS_X_API_KEY.COMMON,
  CREDIT_APP_ENPOINT:API_ENDPOINTS.CREDIT_APP_ENPOINT.PROD,
  GOOGLE_MAP_API_KEY: API_ENDPOINTS.GOOGLE_MAP_API_KEY.PROD,
  WAF_URL: API_ENDPOINTS.WAF_URL.PROD,
};

export const environment = defaultsDeep(override, environmentDefaults);
